import React from "react"
import styled, { css } from "styled-components"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { renderRichText } from "gatsby-source-contentful/rich-text"

// Utils
import { richTextOptions } from "@utils/knowledge-center"

const size = {
  tablet: 950,
  mobile: 600,
}

const above = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const ArticleImageWrapper = styled.div`
  margin-top: 48px;

  ${above.mobile`margin-top:64px`}

  ${above.tablet`
margin-top:80px;
`}
  .image {
    padding: 8px;
    border: 0.5px solid #e5e5e5;
  }

  .caption p {
    font-size: 14px;
    line-height: 17.6px;
    color: var(--grey);
    margin-top: 12px !important;
  }
`

const ArticleImage = props => {
  return (
    <ArticleImageWrapper className="article-image article-component">
      <img
        className="image"
        src={`${props.fields.image.file.url}`}
        alt={`${props.fields.image.title}`}
      />
      <div className="caption">
        {renderRichText(props.fields.caption, richTextOptions(props))}
      </div>
    </ArticleImageWrapper>
  )
}

export default ArticleImage
